interface NextIconProps {
    color?: string;
    className?: string;
}

function NextIcon({ color = 'currentColor', className }: NextIconProps) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path d="M5 5v14l10-7z" fill={color} />
            <rect x="17" y="5" width="2.2" height="14" rx="1" fill={color} />
        </svg>
    );
}

export default NextIcon;
